import {ContextActionApi} from '../api/ContextActionApi';
import {BaseValidatedClass} from '../BaseValidatedClass';
import {ImmutableHtmlNode} from '../modifications/ImmutableNode';

export class ContextAction extends BaseValidatedClass {
  api!: ContextActionApi;

  /** List of methods that must be implemented by subclasses */
  private static readonly REQUIRED_METHODS = ['getId', 'getIcon', 'getLabel', 'onClick'];

  constructor() {
    super(ContextAction.REQUIRED_METHODS, ContextAction);
  }

  public getId(): string {
    throw new Error('Method getId() must be implemented by the subclass');
  }

  public getIcon(): string {
    throw new Error('Method getIcon() must be implemented by the subclass');
  }

  public getLabel(): string {
    throw new Error('Method getLabel() must be implemented by the subclass');
  }

  public onClick(_node: ImmutableHtmlNode): void {
    throw new Error('Method onClick() must be implemented by the subclass');
  }
}
